import { render, staticRenderFns } from "./MobileDataContent.vue?vue&type=template&id=0216cebe&scoped=true&"
import script from "./MobileDataContent.vue?vue&type=script&lang=js&"
export * from "./MobileDataContent.vue?vue&type=script&lang=js&"
import style0 from "./MobileDataContent.vue?vue&type=style&index=0&id=0216cebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0216cebe",
  null
  
)

export default component.exports